
import { MediaType, MediaTypes } from '../../types/media.type';
import { ZMediaTextDto } from '../../dtos/z-media-text.dto';

const DOCUMENT_NAME_LANGUAGE_REGEX = /[\._][a-zA-Z]{2,3}(?:-[a-zA-Z]{2,3})?(?:\d{2}q|[\._])/;

export class ZMediaText implements ZMediaTextDto {
    url: string;
    language: string;
    iManr: string;
    description: string;
    type: MediaType;
    langNeutralItem: string;
    alternativeLanguages: ZMediaText[] = [];
    constructor({ url, language, iManr, description, type, langNeutralItem }: ZMediaTextDto) {
        this.url = url;
        this.language = language;
        this.iManr = iManr;
        this.description = description;
        this.type = type;
        this.langNeutralItem = langNeutralItem;
    }

    compareByLanguageTo(other: ZMediaText, userLang: string): number {
        if (this.language.toLocaleLowerCase() === userLang) {
            return -1;
        }
        if (other.language.toLocaleLowerCase() === userLang) {
            return 1;
        } else if (this.language.toLocaleLowerCase() === 'en') {
            return -1;
        }
        if (other.language.toLocaleLowerCase() === 'en') {
            return 1;
        }
        if (this.language.toLocaleLowerCase() === 'de') {
            return -1;
        }
        if (other.language.toLocaleLowerCase() === 'de') {
            return 1;
        }
        return this.language.localeCompare(other.language);
    }

    equalsIgnoringLanguage(other: ZMediaText): boolean {
        if (other.langNeutralItem === this.langNeutralItem) {
            return true; // if langNeutralItem is the same, it's the same document in different languages
        }
        // otherwise it might still be the same because langNeutralItem is not always set correctly --> check if document name is the same
        const fuzzyMatch = this.type === MediaTypes.Brochure || this.type === MediaTypes.SparepartsList;
        const thisSelector = !!this.iManr || this.url?.includes('temp_data') ? this.iManr : this.url?.split('/').reverse()[0] ?? '';
        const otherSelector = !!other.iManr || other.url?.includes('temp_data') ? other.iManr : other.url?.split('/').reverse()[0] ?? '';

        if (fuzzyMatch) {
            return thisSelector.split('.')[0] === otherSelector?.split('.')[0];
        }

        return thisSelector?.replace(DOCUMENT_NAME_LANGUAGE_REGEX, '.') === otherSelector?.replace(DOCUMENT_NAME_LANGUAGE_REGEX, '.');
    }
}
